import React from 'react';
import classNames from 'classnames';
import { Color } from '../../enums/color';
import * as styles from './icon.module.sass';
import { IconProps } from './props.type';
import { Size } from '../../enums/size';

export const Icon = (props: IconProps) => {
  const { className, onClick, size = Size.BIG, color = Color.DEFAULT, icon } = props;
  const classProps: string = classNames(styles.icon, styles[color], styles[size], className);

  return (
    <div className={classNames(styles.background_available, icon)} onClick={onClick}>
      <span className={classProps} />
    </div>
  );
};
